import React, { useEffect, useRef, useState } from "react";
import { XCircle } from "react-bootstrap-icons";
import styles from "./TagInput.module.scss";

export default function TagInput(props){
    const {validator,separators, onChange, name, id,value} = props;
    
    var separatorsCompare = [13];
    
   
            if (Array.isArray(separators)){
                separators.forEach( oneSeparator => {
                    if (typeof(oneSeparator)=="string"){
                        separatorsCompare.push(oneSeparator.charCodeAt(0));
                    }else{
                        if (typeof(oneSeparator)=="number")
                            separatorsCompare.push(oneSeparator);
                    }
                })
            }
   
    const inputRef = useRef();
    const [tags,setTags] = useState(Array.isArray(value)?value:[]);
    const [inputValue, setInputValue] = useState('');
    const [inputError, setInputError] = useState(false);
    function changeInput(evc){
        setInputError(false);
        setInputValue(evc.target.value);
    }

    function onBlurInput(evkd){
        if (evkd.target.value.trim()!==""){
            if (validator){
                if (validator(evkd.target.value)){
                    let newTags = tags;
                    newTags.push(evkd.target.value.trim());
                    setTags(newTags);
                    if (onChange){
                        onChange({
                            target:{
                                value: newTags,
                                name: name,
                                id: id
                            }
                        });
                    }
                    setInputValue('');
                }else{
                    setInputError(true);
                }
            }else{
                let newTags = [...tags];
                newTags.push(evkd.target.value.trim());
                setTags(newTags);
                if (onChange){
                    onChange({
                        target:{
                            value: newTags,
                            name: name,
                            id: id
                        }
                    });
                }
                setInputValue('');
            }
        }
    }
    function keyDownInput(evkd){
        if (separatorsCompare.indexOf(evkd.keyCode)>=0){
            evkd.stopPropagation();
            evkd.preventDefault();
            if (evkd.target.value.trim()!==""){
                
                if (validator){
                    
                    if (validator(evkd.target.value)){
                        let newTags = tags;
                        newTags.push(evkd.target.value.trim());
                        setTags(newTags);
                        if (onChange){
                            onChange({
                                target:{
                                    value: newTags,
                                    name: name,
                                    id: id
                                }
                            });
                        }
                        setInputValue('');
                        inputRef.current.focus();
                    }else{
                        setInputError(true);
                    }
                }else{
                    
                    let newTags = [...tags];
                    newTags.push(evkd.target.value.trim());
                    setTags(newTags);
                    if (onChange){
                        onChange({
                            target:{
                                value: newTags,
                                name: name,
                                id: id
                            }
                        });
                    }
                    setInputValue('');
                    inputRef.current.focus();
                }
            }
        }else{
            if ((evkd.keyCode==8)&& (evkd.target.value.trim()==""))
            {
                // Borrar una tag con el backspace
                let newTags = [...tags];
                newTags.pop();
                    setTags(newTags);
                    if (onChange){
                        onChange({
                            target:{
                                value: newTags,
                                name: name,
                                id: id
                            }
                        });
                    }
                    setInputValue('');
                    inputRef.current.focus();
            }
        }
    }
    function deleteTag(id){
        let newTags = tags.filter((theTag,indx)=> indx!==id );
        setTags(newTags);
        if (onChange){
            onChange({
                target:{
                    value: newTags,
                    name: name,
                    id: id
                }
            });
        }
        inputRef.current.focus();
    }
    return <div className={styles.wrapper}>
        <div className={styles.tagcont}>
            {
                tags.map((oneTag,idx)=><div className={styles.tag} key={idx}>  
                    {oneTag} <div className={styles.close} onClick={(evc)=>{deleteTag(idx)}}><XCircle data-tag={idx} /></div>
                </div>)
            }
        </div>
        <div className={styles.inputcont}>
            <input ref={inputRef} type="text" value={inputValue} className={styles.input+" "+((inputError)?(styles.inputerror):'') } onChange={changeInput} onKeyDown={keyDownInput} onBlur={onBlurInput} />
        </div>
    </div>;
}